import { Navigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { useApplication } from "../hooks/UseApplication";
import { getUserType, UserType } from "../service/Enums";

const AdminRoute = ({ children }) => {
    const { user, authorized } = useApplication();

    if (authorized === "WAITING") return <CircularProgress />;
    if (authorized !== "AUTHORIZED") return <Navigate to="/" replace />;

    const currentUser = typeof user === "string" ? JSON.parse(user) : user;
    return getUserType(currentUser) === UserType.ADMIN.value
        ? children
        : <Navigate to="/map" replace />;
};

export default AdminRoute;
